import adminRequest from '../../../config/adminRequest';
import { UsdtUri } from '../../core/configs/services';
import { AdminResponse } from '../models/adminResponse';
import { BoSignHelper } from '../../../core/providers/helper/boSign-helper';
import { normalizeOtp } from '../../core/utils/otp';

export interface PoolWallet {
  id: string;
  address: string;
  status: 'INCUBATING' | 'READY' | 'CLAIMED';
  mintedAt: string;
  dustSeededAt: string | null;
  activateRequested: number;
  activatedAt: string | null;
  readyAt: string | null;
  claimedAt: string | null;
  claimedBy: string | null;
  claimedType: string | null;
}

export interface PoolCounts {
  incubating: number;
  ready: number;
  claimed: number;
  activated: number;
  orphanClaimed: number;
}

export class WalletPoolProvider {
  static async list(): Promise<{ counts: PoolCounts; items: PoolWallet[] }> {
    const res = await adminRequest.get<AdminResponse<{ counts: PoolCounts; items: PoolWallet[] }>>(
      UsdtUri('/admin/wallet-pool'),
      { params: {} },
    );
    return res.data.data;
  }

  /** 手動補貨:mint(不上鏈開通)進池,後端會 clamp 到 POOL_TARGET 缺額。 */
  static async replenish(count: number): Promise<{ minted: number; failed: number }> {
    const res = await adminRequest.post<AdminResponse<{ minted: number; failed: number }>>(
      UsdtUri('/admin/wallet-pool/replenish'), { count });
    return res.data.data;
  }

  static async activate(ids: string[]): Promise<{ marked: number }> {
    const res = await adminRequest.post<AdminResponse<{ marked: number }>>(
      UsdtUri('/admin/wallet-pool/activate'),
      { ids },
    );
    return res.data.data;
  }

  static async checkout(
    id: string,
    input: {
      as: 'user' | 'operation';
      systemId?: string;
      uid?: string;
      type?: string;
      note?: string;
      code: string;
    },
  ): Promise<{ address: string }> {
    const data = { ...input, code: normalizeOtp(input.code) };
    const res = await adminRequest.post<AdminResponse<{ address: string }>>(
      UsdtUri(`/admin/wallet-pool/${id}/checkout`),
      { ...data, boSign: BoSignHelper.generate(data) },
    );
    return res.data.data;
  }
}
